"use client";

import globalStylesheetHref from "@/app/globals.css?url";
import { useEffect, useState } from "react";
import posthog from "posthog-js";
import { ConvexError } from "convex/values";
import { RouteErrorView } from "@/components/error/route-error-view";
import { resolveTelemetryEnvironment } from "@/lib/telemetry-runtime";
import { isExpectedApplicationError } from "@/lib/telemetry/expected-errors";
import { isChunkLoadError } from "@/lib/chunk-load-recovery";
import { currentPublicConfig } from "@/lib/public-config";
import { PublicConfigScript } from "@/components/layout/public-config-script";

export function GlobalErrorDocument({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const isRecoverableChunkLoadError = isChunkLoadError(error);
  const [publicConfig] = useState(currentPublicConfig);

  useEffect(() => {
    if (error instanceof ConvexError || isExpectedApplicationError(error)) {
      return;
    }
    if (isRecoverableChunkLoadError) return;
    if (resolveTelemetryEnvironment() === "development") {
      return;
    }
    try {
      posthog.captureException(error);
    } catch {
    }
  }, [error, isRecoverableChunkLoadError]);

  return (
    <html lang="en" suppressHydrationWarning>
      <body suppressHydrationWarning>
        <PublicConfigScript config={publicConfig} />
        <link rel="stylesheet" href={globalStylesheetHref} precedence="default" />
        <RouteErrorView
          error={error}
          reset={reset}
          skipErrorCapture={!isRecoverableChunkLoadError}
          reportable={false}
          navigation={{ label: "Go to homepage", href: "/" }}
          containerClassName="mx-auto flex min-h-dvh max-w-lg flex-col items-center justify-center px-6 py-12 text-center"
        />
      </body>
    </html>
  );
}
